module.exports = __webpack_public_path__ + "static/media/kendall.e0508cc9.jpg";